var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"avatar",attrs:{"data-initial":_vm.fullNameInitialLetter}},[(_vm.user.photoURL)?_c('img',{attrs:{"src":_vm.user.photoURL}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }